import api from './api';

const API_PREFIX = "api/trend-mapping-selection";

/**
 * Get trend mapping selection for a specific account and page
 * Selections are account-wise and page-wise
 * @param {Object} params - Query parameters
 * @param {string} params.pageType - Page type (e.g., HOSPITAL, COMMUNITY_TRANSFER, DECEASED, ADMISSION, OVERALL)
 * @returns {Promise} API response
 */
const getTrendMappingSelection = async (params) => {
    const response = await api.get(API_PREFIX, { params });
    return response;
};

/**
 * Create a new trend mapping selection
 * Selections are account-wise and page-wise
 * @param {Object} body - Selection data
 * @param {string} body.name - Selection name
 * @param {string} body.pageType - Page type
 * @param {string[]} body.selectedCards - Array of selected card IDs
 * @param {Object} body.selectedItemsByCard - Object mapping cardId to array of selected item IDs
 * @param {Object} body.filterMode - Filter mode (keepAll, keepSome, removeAll)
 * @param {string[]} body.selectedFilterCards - Array of selected filter card IDs (for keepSome mode)
 * @param {number} body.similarityTolerance - Similarity tolerance percentage
 * @returns {Promise} API response
 */
const createTrendMappingSelection = async (body) => {
    const response = await api.post(API_PREFIX, body);
    return response;
};

/**
 * Update an existing trend mapping selection
 * @param {string} id - Selection ID
 * @param {Object} body - Updated selection data
 * @returns {Promise} API response
 */
const updateTrendMappingSelection = async (id, body) => {
    const response = await api.put(`${API_PREFIX}/${id}`, body);
    return response;
};

/**
 * Delete a trend mapping selection
 * @param {string} id - Selection ID
 * @returns {Promise} API response
 */
const deleteTrendMappingSelection = async (id) => {
    const response = await api.delete(`${API_PREFIX}/${id}`);
    return response;
};

export {
    getTrendMappingSelection,
    createTrendMappingSelection,
    updateTrendMappingSelection,
    deleteTrendMappingSelection,
};

